import React, { Component } from 'react'
import PropTypes from 'prop-types'

class IFrame extends Component {
  render () {
    const {
      content
    } = this.props

    return (
      <iframe ref={this.iframeElementRecieved} title='iframe content' src={content} style={{ border: 0 }} />
    )
  }

  iframeElementRecieved = (el) => {
    if (!el) return

    if (el.src.includes('youtube.com')) {
      const desiredWidth = el.parentElement.clientWidth
      const aspectRatio = el.clientHeight / el.clientWidth

      el.width = desiredWidth
      el.height = desiredWidth * aspectRatio
    }
  }
}

IFrame.propTypes = {
  content: PropTypes.string
}

export default IFrame



// WEBPACK FOOTER //
// ./src/components/contentDisplay/IFrame.js